var map = {
	"./arrow.svg": "1106",
	"./ball.svg": "694e",
	"./bg-footer.svg": "f99a",
	"./bg-sm.png": "14e0",
	"./bg-text.svg": "c15c",
	"./download.svg": "9f0f",
	"./fiba.svg": "9202",
	"./good.svg": "0d3a",
	"./home.svg": "e3e6",
	"./logo.svg": "1ae4",
	"./people.png": "f87f",
	"./phone.webp": "f37e",
	"./register.svg": "438f",
	"./service.svg": "71b4",
	"./sign.png": "de03",
	"./trophy.png": "7116",
	"./warning.svg": "449c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";